<section class="access-detran">
  <div class="container">
    <div class="header">
      <h2>ACESSAR SISTEMA DETRAN</h2>
    </div>

    <div class="form-wrapper">
      <form [formGroup]="form" class="form-access">
        <mat-label>Matrícula DETRAN:</mat-label>
        <mat-form-field class="form-field" appearance="outline">
          <input
            formControlName="user"
            matInput
            type="text"
            maxlength="6"
            placeholder="Digite sua matrícula de 6 dígitos"
          />
        </mat-form-field>

        <mat-label>Senha:</mat-label>
        <mat-form-field class="form-field" appearance="outline">
          <input
            formControlName="password"
            matInput
            type="password"
            maxlength="6"
            placeholder="Digite sua senha de 4 dígitos"
          />
        </mat-form-field>

        <div class="button-group">
          <button mat-stroked-button color="warn" class="btn-cancel" (click)="cancel()">
            <i class="material-icons">cancel</i>Cancelar
          </button>
          <button mat-raised-button color="primary" class="btn-continue" (click)="submit()">
            <i class="material-icons">check_circle</i>Continuar
          </button>
        </div>
      </form>

      <div class="contact-info">
        <h3>Contato para regularizar seu usuário Detran</h3>
        <p><mat-icon>person</mat-icon> Lucas Albiani - Coordenador CRT</p>
        <p><mat-icon>email</mat-icon> E-mail: lucas.costa&#64;detran.ba.gov.br</p>
        <p><mat-icon>phone</mat-icon> Telefone: 3116-2205</p>
      </div>
    </div>
  </div>
</section>
